
const slideInPanel = {

    wrapperId: "slide-in-wrapper",

    //beallitja a annak wrappernek a magassagat amin belul latszodnak a beuszo menuk
    // ezt meg kell hivni viewport meret valtozasoknal
    setWrapperMarginTop(mt) {
        document.getElementById(this.wrapperId).style.marginTop = mt + "px";
    },

    getWrapperHeight() {
        return document.getElementById(this.wrapperId).offsetHeight;
    },

    operate(id,state) { // state = true || "on" || false || "off";

        elem = document.getElementById(id);

        const slideIn =()=> {
            elem.style.opacity = "100";
            elem.style.transform = "translateY(0%)";
            elem.style.pointerEvents = "all";
        }
        const slideOut =()=> {
            elem.style.opacity = "0";
            elem.style.transform = "translateY(-100%)";
            elem.style.pointerEvents = "none";
        }
    
        if (typeof(state)==='undefined') {
            if (elem.style.transform == "translateY(-100%)") {
                slideIn();
                return;
            } else {
                slideOut();
                return;
            }
        }

        if (typeof(state) === "string" && state.trim() === "on") {
            state = true;
        } else if (typeof(state) === "string" && state.trim() === "off") {
            state = false;
        } 

        if ( typeof(state) === 'boolean' && state ) {
            slideIn();
            return;
        } else {
            slideOut();
            return;
        }
    },

    showWrapper(visibility) {
        if (visibility) {
            document.getElementById(this.wrapperId).style.outline = "8px solid rgba(191, 0, 64, 0.3)";
            document.getElementById(this.wrapperId).style.outlineOffset = "-8px";
        } else {
            document.getElementById(this.wrapperId).style.outline = null;
            document.getElementById(this.wrapperId).style.outlineOffset = null;
        }
    }

}

const menu = {

    mobileMenuId: 'menu-mobile',


    fixedViewOn() {

    // kikapcsoljuk a scrollt, es rahuzunk egy overlayt az oldalra

        // datasetbe mentjuk a scroll y-t
        document.body.dataset.savedScrollY = window.scrollY;

        // csinalunk egy overlay divet
        var overlayDiv = document.createElement('div');
        overlayDiv.classList.add('n_overlay');
        document.body.appendChild(overlayDiv);

        //document body-ra 'n_fixed-view' class
        document.body.classList.add('n_fixed-view');

        // kompenzaljuk a scrollbar eltuneset ha kell
        scrollBar.compensate(true);

        // beallitjuk a scroll y-t (azert mert neha elcsuszik)
        window.scrollTo(0,document.body.dataset.savedScrollY);

    },

    fixedViewOff() {

    // visszakapcsoljuk a scrollt, es eltuntetjuk az overlayt

        // eltuntetjuk az overlay divet
        document.querySelector('.n_overlay').remove();

         // document body-rol levesszuk a 'n_fixed-view' classt
        document.body.classList.remove('n_fixed-view');

         // visszacsinaljuk a scrollbar kompenzalast
        scrollBar.compensate(false);

        // beallitjuk a scroll y-t (azert mert neha elcsuszik)
        window.scrollTo(0,document.body.dataset.savedScrollY);
        
    },

    mobileMenuOn() {
        document.body.classList.add('n_mobile-menu-on');

        //behuzzuk fentrol a mobilmenut a kepbe
        slideInPanel.operate(this.mobileMenuId,true);

        //bekapcsoljuk a Fixed View-t
        // this.fixedViewOn();

        document.getElementById(this.mobileMenuId).style.pointerEvents = "all";

    },
    
    mobileMenuOff() {
        
        //kimegy a mobilmenu a kepbol
        slideInPanel.operate(this.mobileMenuId,false);
        
        //kikapcsoljuk a Fixed View-t
        // this.fixedViewOff();
        
        document.getElementById(this.mobileMenuId).style.pointerEvents = "none";
        document.body.classList.remove('n_mobile-menu-on');

    },

    setMobileMenuHeight(height) {
        document.getElementById(this.mobileMenuId).style.maxHeight = height + "px";
    },



    triggerMobileSubmenu(targetId,command) {
        let mobileSubmenu = document.getElementById(targetId);
        const open =()=> {
            mobileSubmenu.style.maxHeight = mobileSubmenu.scrollHeight + "px";
        }
        const close =()=> {
            mobileSubmenu.style.maxHeight = 0;
        }
        if (typeof(command)==="undefined" || command =="toggle") {
            if (mobileSubmenu.style.maxHeight.length != 0 && parseInt(mobileSubmenu.style.maxHeight) <= 5 ) {
                open();
            } else {
                close();
            }
        } else if ( command) {
            open();
        } else if (!(command)) {
            close();
        }

    },

    setAnimationTiming(addDelayTo,removeDelayFrom) {
        let getDelayTarget = document.getElementById(addDelayTo);
        let loseDelayTarget = document.getElementById(removeDelayFrom);
        tailwindDelayClass = "delay-300";
        getDelayTarget.classList.add(tailwindDelayClass);
        loseDelayTarget.classList.remove(tailwindDelayClass);
    }

}

const scrollBar = {

    getWidth() {

    //px-ben visszaadja, hogy milyen szeles a scrollbar

        // Creating invisible container
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);
    
        // Creating inner element and placing it in the container
        const inner = document.createElement('div');
        outer.appendChild(inner);
    
        // Calculating difference between container's full width and the child width
        const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    
        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);
    
        return scrollbarWidth;
    },

    checkBody() {

    // ha nem scrollozhato a body akkor 0-t ad, ha scrollozhato akkor a scrollbar szelesseget px-ben

        // Get document height
        // https://stackoverflow.com/questions/1145850/how-to-get-height-of-entire-document-with-javascript
        let body = document.body,
        html = document.documentElement;

        let documentHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );

        if (documentHeight > window.innerHeight) {
            return scrollBar.getWidth();
        } else {
            return 0;
        }
    },

    compensate(on) {

    // Azokra az elemekra aminek 'data-scrollbar-fix' attributuma van lehet
    // 'margin-right', 'padding-right', vagy 'right' css attributumot rakni vagy levenni, ami akkora mint a scrollbar.
    //('data-scrollbar-fix' erteketol fugg, hogy melyik css attr., az ertek lehet 'mr','pr' vagy 'r')
    // Ha egy elemen mar van az adott css attributum, es 0-nal nagyobb akkor nem mukodik jol - TODO: legyen okosabb
    // 
    // Mindez arra jo, hogy az elemek pozicioja ne ugraljon bizonyos bongeszokben amikor a body-t overflow-hiddenre allitjuk

        const identity = "scrollBar.compensate";

        // csekkoljuk a fuggveny parametert
        if ( typeof(on) !== "boolean" ) { on = true;}

        // van-e scrollbar a bodyn / mekkora a scrollbar
        scrollbar = scrollBar.checkBody();

        //ha nincs scrollbar, akkor megallunk
        if (!scrollbar && on == true) {
            return;
        }

        // levalogatjuk az elemeket amiknek 'data-scrollbar-fix' attributuma van
        let elems = document.querySelectorAll("*[data-scrollbar-fix]");

        // a 'data-scrollbar-fix' attributumnak ezek az ertekei lehetnek
        const methods = ['mr','pr','r'];
    
        // vegigmegyunk az elemeken
        elems.forEach(elem => {
    
            //megnezzuk mi a metodus
            let method = elem.dataset.scrollbarFix;
    
            //megnezzuk szerepel-e a metodus a lehetseges metodusok kozott, ha nem akkor megallunk
            if ( !( methods.includes(method) )) {
                return;
            }
    
            // a metodus alapjan meghatarozzuk es mentjuk a css tulajdonsagot
            let cssProp = "";
            if (method == 'mr') {
                cssProp = 'marginRight';
            } else if (method == 'pr') {
                cssProp = 'paddingRight';
            } else if (method == 'r') {
                cssProp = 'right';
            } 
            
            // ha 'true' parameterrel hivtuk a fuggveny, rarakjuk az elemre a kompenzalast
            // ha 'false' parameterrel hivtuk a fuggveny, lenullazuk a css tulajdonsagot
            if (on) {
                elem.style[cssProp] = scrollbar + "px";
            } else {
                elem.style[cssProp] = "0";
            }
    
        });
    }
}

const scroll = {
    _previousTop: 0, 
    _direction: 0,// none: 0||down: 1||up: -1
    _previousDirection: 0,
    get direction () {
        return this._direction;
    },
    checkDirection () {
        let scrollTop = window.scrollY;
        scrollTop >= this._previousTop ? this._direction = 1 : this._direction = -1;
        this._previousTop = scrollTop;
        return this._direction;
    },
    track() {
        let that = this;
        window.addEventListener('scroll', function(){
            that.checkDirection();
        });
    },
    directionChangeEvent () {
        let directionChange = 0;
        if (this._direction != this._previousDirection && this._previousDirection != 0) {
            directionChange = this._direction;
        }
        this._previousDirection = this._direction;
        // console.log(directionChange);
        return directionChange;
    },
    scrollToY (y,duration) {
        if ( typeof(duration) !== "undefined" && typeof(parseInt(duration)) === 'number' ) {
            duration = Math.abs(Math.floor(parseInt(duration)));
            // console.log("Duration set to " + duration)
        } else {
            duration = 300;
        }
        let _tic = 16.66666666666666;//60fps
        let _targetY = y;
        let _scrollStep = Math.floor(Math.abs(window.scrollY - _targetY) / (duration / _tic));
        let _inverter = 1;
        let _nextScrollTo = window.scrollY;
        if (window.scrollY == _targetY) {
            return;
        }


        window.scrollTo(0,window.scrollY - window.scrollY % _scrollStep);


        if (_targetY < window.scrollY) {_inverter = -1};
        _scrollStep *= _inverter;
        

        let operate =()=> {
            
            // console.log('start! Duration: '+duration+' Step:' +_scrollStep );
            if ( Math.abs(_nextScrollTo - _targetY) > Math.abs(_scrollStep) && _scrollStep != 0) {
                window.scroll(0,_nextScrollTo);
                _nextScrollTo += _scrollStep;
            } else {
                window.scroll(0,_targetY);
                console.log('stop');
                clearInterval(_scrollTimer);
            }
        }
        let _scrollTimer = setInterval(operate,_tic);

    }
}

class SlidingSticky {

    // scroll{}; and scroll.track() needed!

    constructor (id, offset) {
        this._id = id.trim();
        if (typeof(offset) === 'number') {
            this._offset = Math.floor(Math.abs(offset));
        } else {
            this._offset = 0;
        }
        this._savedTop = 0;
        this._savedScrollTop = 0;
        this._elem = null;
        this._top = 0;
        this._scrollDirectionChange = 0;
        this._scrollDiff = 0;
        this._disabled = false;
    }
    refresh() {
        this._elem = document.getElementById(this._id);
        this._top = this._elem.getBoundingClientRect().top;
    }
    start() {
        this.refresh();
        let that = this;
        window.addEventListener('scroll', function(){
            that.operate();
        });
    }
    get top() {
        return this._top;
    }
    get id()  {
        return this._elem.id;
    }
    operate() {
        if (this._disabled == true) {
            return;
        }
        this._top = this._elem.getBoundingClientRect().top;
        this._scrollDirectionChange = scroll.directionChangeEvent();
        if (this._scrollDirectionChange) {
            this._savedTop = this._top;
            this._savedScrollTop = window.scrollY;
        }
        this._scrollDiff = Math.abs(window.scrollY - this._savedScrollTop);

        var pos = 0;
        if (scroll.direction == 1) {
            // scroll down
            pos = Math.max(this._savedTop - this._scrollDiff , (this._elem.offsetHeight + this._offset) * -1);
        } else if (scroll.direction == -1 && window.scrollY) {
            // scroll up
            pos = Math.min(this._savedTop - this._scrollDiff * -1,0);
        }

        this._elem.style.top =  pos +  "px";

        // move article headers if menu pops up on scroll up
        if (pos > -120 && window.scrollY > 360) {
            document.body.classList.add('n_menu-is-visible');
        } else {
            document.body.classList.remove('n_menu-is-visible');
        }

    }
    reset() {
        this._elem.style.top = 0;
        this._top = 0;
        this._savedTop = this._top;
        this._savedScrollTop = window.scrollY;
    }
    disable() {
        this._disabled = true;
        this.reset();
    }
    enable() {
        this._disabled = false;
    }

}

const customCursor = {

    _init: false,
    _cursor: null,
    _elems: null,
    _customClasses: [],

    track() {

        var that = this;

        window.onmousemove = function(e) {

            var mouseX = e.clientX;
            var mouseY = e.clientY;

            that._cursor.style.top = mouseY + "px"; 
            that._cursor.style.left = mouseX + "px";
        

          };
    },

    trackHover() {

        var that = this;
        this._elems.forEach( function(elem) {
            elem.style.cursor = "none";
            elem.addEventListener('mouseenter', e => {
                that.addCustomClass(elem.dataset.ccursor);
            });
            elem.addEventListener('mouseleave', e => {
                that.removeCustomClasses();
            });

        });

    },

    init() {

        var that = this;

        if (!isTouchDevice()) {
            document.addEventListener("DOMContentLoaded", function (event) {

                that._cursor = document.getElementById("custom-cursor");
                that._elems = document.querySelectorAll("*[data-ccursor]");
                that.track();
                that.trackHover();
                that._init = true;

            });
        }
    },

    addCustomClass(className) {
        if(!this._customClasses.includes(className)) {
            this._customClasses.push(className);
        }
        this.removeCustomClasses();
        if (this._init) {
            this._cursor.classList.add(className);
        }
    },

    removeCustomClasses() {
        if (this._init) {
            this._cursor.classList.remove.apply( this._cursor.classList, this._customClasses );
        }
    }

}
customCursor.init();

// TODO: accordion class
class accordion {
    constructor(id) {
        this._id = id.trim();
    }
}


const testFunction  =(message)=> {
    console.log("Test function's message: " + message);
}

const njq = {
    index (el) {
        if (!el) return -1;
        var i = 0;
        do {
          i++;
        } while (el = el.previousElementSibling);
        return i;
    },
    viewportWidth () {
        return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    },
    viewportHeight() {
        return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    },
    onWinResize(funct) {

        let timer;
        window.addEventListener('resize', (e)=> {
            clearTimeout(timer);
            timer = setTimeout(funct, 200);
        });

    },
    documentReady(funct,atResize) {
        let that = this;
        window.addEventListener('DOMContentLoaded',(e) => {
            funct();
            if (atResize) {
                that.onWinResize(funct);
            }
        });
    },
    r(funct,atResize) {
        //Alias for documentReady
        this.documentReady(funct,atResize);
    },
}


//bezarja a menuket bizonyos viewport szelesseg felett/alatt
const closeMenusAtBp =(bp)=> {
    njq.r( () => {
        if (njq.viewportWidth() <= bp) {
            submenuSwitches.forEach((mySwitch)=>{
                mySwitch.off();
            });
        } else {
            mobileMenuSwitch.off();
        }
    }, true)
}
closeMenusAtBp(960);

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

function showComingSoon(elem) {
    const clickedCards = document.querySelectorAll(".n_card--reference.clicked");

    clickedCards.forEach(function(card) {
        card.classList.remove('clicked');
    });

    elem.closest('.n_card--reference').classList.add('clicked'); return false;
}